import actCodesData from './specialist-act-codes.json';
import { ActCode } from '../domain/activity/act/model/Act';

export const getActCodesDataWithSpecialtyOverrides = (): ActCode[] => actCodesData as ActCode[];

export function findCodeDetail(code: string): ActCode | undefined {
  return getActCodesDataWithSpecialtyOverrides().find((actCode) => actCode.code === code);
}
